import { useQuery } from 'react-query';
import { QueryKey } from '../constants/queryKey';
import useApi from '../api';

const useTenant = () => {
    const { getTenant } = useApi();

    const query = useQuery([QueryKey.Tenant], () => getTenant(), {
        staleTime: 0,
    });

    const { data: tenant, isLoading, isError, isFetched } = query;

    return {
        tenant,
        isLoading,
        isFetched,
        isError,
    };
};

export default useTenant;
